import React from 'react';
import { Field, Form } from 'redux-form';
import { withStyles } from 'material-ui';
import { DropDownMenu } from 'entoro-shared';
import ImageInput from './ImageInput';

const styles = () => ({
  container: {
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

class InvestmentType extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = props.handleSubmit;
    this.state = {
      showInvestmentType: false,
    };
    this.handleTypeOfInvestmentChange =
      this.handleTypeOfInvestmentChange.bind(this);
  }
  handleTypeOfInvestmentChange(event) {
    const selectedOption = event.target.value;

    if (selectedOption === 'EN') {
      this.setState({ showInvestmentType: true });
    } else {
      this.setState({ showInvestmentType: false });
    }
  }
  render() {
    const { showInvestmentType } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <div style={{ maxWidth: '100%' }}>
          <p>Are you investing as an individual or an entity?</p>

          <Field
            label='Type Of Investment'
            component={DropDownMenu}
            name='typeOfInvestment'
            options={[
              { value: 'IN', label: 'Individual' },
              { value: 'EN', label: 'Entity' },
            ]}
            onChange={this.handleTypeOfInvestmentChange}
          />
          {showInvestmentType ? (
            <div>
              <p>Please specify an entity type</p>

              <Field
                label='Entity Type'
                component={DropDownMenu}
                name='entityType'
                options={[
                  { value: 'LLC', label: 'LLC' },
                  { value: 'LP', label: 'LP' },
                  { value: '401K', label: '401K' },
                  { value: 'IRA', label: 'IRA' },
                  { value: 'TR', label: 'Trust' },
                ]}
              />
              <p>Please upload your Certificate of Incorporation Document</p>
              <ImageInput
                source='investmentTypeDocument'
                addLabel
                label='Image'
                aspect={1 / 1}
                recommendedAspect='recommended minimum image width: 200px'
              />
            </div>
          ) : (
            <p></p>
          )}
        </div>
        <br />
      </Form>
    );
  }
}

// function InvestmentType({ handleSubmit, offer, investorUser: { country } }) {
//   console.log(countries.options);
//   return (
//     <Form onSubmit={handleSubmit}>
//       <div style={{ maxWidth: '100%' }}>
//         <p>Are you investing as an individual or an entity?</p>
//         <Field
//           label='Type Of Investment'
//           component={DropDownMenu}
//           name='typeOfInvestment'
//           options={[
//             { value: 'IN', label: 'Individual' },
//             { value: 'EN', label: 'Entity' },
//           ]}
//         />

//         <DependentInput
//           dependsOn='typeOfInvestment'
//           resolve={(value) => value === 'EN'}
//         >
//           <p>Please upload your Certificate of Incorporation Document</p>
//           <ImageInput
//             source='investmentTypeDocument'
//             addLabel
//             label='Image'
//             aspect={1 / 1}
//             recommendedAspect='recommended minimum image width: 200px'
//           />
//         </DependentInput>
//       </div>
//       <br />
//     </Form>
//   );
// }

export default withStyles(styles)(InvestmentType);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/InvestmentType.js